var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09427 2.86021C3.87417 3.30957 4.0526 3.85599 4.4928 4.08068C8.18822 5.96688 10.1622 7.80438 12.0024 11.1569C12.2895 11.68 12.2895 12.32 12.0024 12.8431C10.1622 16.1956 8.18822 18.0331 4.4928 19.9193C4.0526 20.144 3.87417 20.6904 4.09427 21.1399C4.31437 21.5891 4.84965 21.7713 5.28985 21.5466C9.26397 19.5181 11.5216 17.441 13.5571 13.7325C14.1476 12.6569 14.1476 11.3431 13.5571 10.2675C11.5216 6.559 9.26397 4.48185 5.28985 2.45338C4.84965 2.2287 4.31437 2.41084 4.09427 2.86021Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0943 2.86021C10.8742 3.30957 11.0526 3.85599 11.4928 4.08068C15.1882 5.96688 17.1622 7.80438 19.0024 11.1569C19.2895 11.68 19.2895 12.32 19.0024 12.8431C17.1622 16.1956 15.1882 18.0331 11.4928 19.9193C11.0526 20.144 10.8742 20.6904 11.0943 21.1399C11.3144 21.5891 11.8496 21.7713 12.2898 21.5466C16.264 19.5181 18.5216 17.441 20.5571 13.7325C21.1476 12.6569 21.1476 11.3431 20.5571 10.2675C18.5216 6.559 16.264 4.48185 12.2898 2.45338C11.8496 2.2287 11.3144 2.41084 11.0943 2.86021Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightDouble);
export default __webpack_public_path__ + "static/media/Arrow-Right-Double.4c0441c9.svg";
export { ForwardRef as ReactComponent };